class AudioRecorder {
    constructor(stream) {
        this.ondataavailable = null;
        this.onerror = null;
        this.onpause = null;
        this.onresume = null;
        this.onstart = null;
        this.onstop = null;
        let newStream = new MediaStream(stream.getAudioTracks());
        this.mediaRecorder = new MediaRecorder(newStream, { mimeType: AudioRecorder.mimeType });
        this.mediaRecorder.ondataavailable = (e) => { var _a; return (_a = this.ondataavailable) === null || _a === void 0 ? void 0 : _a.call(this, e); };
        this.mediaRecorder.onstart = (e) => { var _a; return (_a = this.onstart) === null || _a === void 0 ? void 0 : _a.call(this, e); };
        this.mediaRecorder.onstop = (e) => { var _a; return (_a = this.onstop) === null || _a === void 0 ? void 0 : _a.call(this, e); };
        this.mediaRecorder.onerror = (e) => { var _a; return (_a = this.onerror) === null || _a === void 0 ? void 0 : _a.call(this, e); };
        this.mediaRecorder.onpause = (e) => { var _a; return (_a = this.onpause) === null || _a === void 0 ? void 0 : _a.call(this, e); };
        this.mediaRecorder.onresume = (e) => { var _a; return (_a = this.onresume) === null || _a === void 0 ? void 0 : _a.call(this, e); };
    }
    get state() {
        return this.mediaRecorder.state;
    }
    start(interval = AudioRecorder.mediaRecorderDataInterval) {
        this.mediaRecorder.start(interval);
    }
    stop() {
        this.mediaRecorder.stop();
    }
    pause() {
        this.mediaRecorder.pause();
    }
    resume() {
        this.mediaRecorder.resume();
    }
    static getSingleChunk(stream) {
        return new Promise((resolve, reject) => {
            const audioTracks = stream.getAudioTracks()[0];
            const newStream = new MediaStream([audioTracks]);
            const mediaRecorder = new MediaRecorder(newStream, { mimeType: AudioRecorder.mimeType });
            mediaRecorder.ondataavailable = function (e) {
                resolve(e.data);
            };
            mediaRecorder.start();
            setTimeout(function () {
                mediaRecorder.stop();
            }, 300);
        });
    }
}
AudioRecorder.mediaRecorderDataInterval = 100;
AudioRecorder.mimeType = 'audio/webm;codecs=pcm';
AudioRecorder.mimeTypeSupport = MediaRecorder.isTypeSupported(AudioRecorder.mimeType);
//# sourceMappingURL=audio_recorder.js.map